/**
 * Created by Andrey Popov on 3/16/21.
 */

const DialogueView = cc.Node.extend({
    ctor: function (...args) {
        this._super();

        this._windowArgs = args;
        this.dialogue = args[0];
        ComponentMap.attach(this, new WindowComponent(this.listBundles(this.dialogue)));

        this.dialogue.on("close", this.close.bind(this), this);
    },

    onWindowLoaded: function (dialogue, options = {}) {
        this.withShadow = options.withShadow !== false;
        this.withSkipButton = options.withSkipButton !== false;
        this.name = "DialogueViewWindow";

        cleverapps.effects.fire("ui.dialogue.show");
        this.onAfterResize();

        dialogue.on("showUp", this.showUp.bind(this), this);
        dialogue.on("changedStage", this.onChangeStage.bind(this), this);
    },

    onShow: function () {
        if (!this.dialogue.isStarted()) {
            this.dialogue.run();
        }
    },
    
    onChangeStage: function (stageData) {
        this.activeContent.onChangeStage(stageData);
    },

    onAfterResize: function () {
        this.onResizeWhileNotLoaded();
        const windowComponent = ComponentMap.get(this, WindowComponent);
        if (windowComponent.isWindowLoaded()) {
            this.generateContent();
        }
    },

    onResizeWhileNotLoaded: function () {
        const scene = cleverapps.Scenes.GetRunningScene();
        const sceneSize = cleverapps.resolution.getSceneSize();
        const safePadding = cleverapps.resolution.getSafePadding();
        const position = scene.convertToNodeSpace(cc.p(scene.width / 2 + safePadding.left, scene.height / 2 + safePadding.bottom));
        const scale = 1 / scene.getScale();
        this.setScale(scale);
        this.setPosition(position.x, position.y);
        this.setContentSize(sceneSize.width, sceneSize.height);
    },

    closeByHardwareBackButton: function () {
        this.dialogue.close();
    },

    generateContent: function () {
        const ContentCtor = DialogueView.getCtor();

        if (this.activeContent && this.activeContent instanceof ContentCtor) {
            return;
        }

        this.activeContent && this.activeContent.removeFromParent();
        this.activeContent = new ContentCtor(this.dialogue, this);
        this.addChild(this.activeContent);

        if (this.shown) {
            this.activeContent.restoreState();
        }

        if (cleverapps.config.debugMode) {
            this.activeContent._debugExclude = true;
        }

        cleverapps.UI.onClick(this.activeContent, () => {
            this.activeContent.screenClicked();
            return true;
        }, {
            interactiveScale: false,
            onDragStart: () => {
                this.activeContent.screenClicked();
                return true;
            }
        });

        if (this.withSkipButton) {
            this.addSkipButton();
        }

        this.dialogue.onContentChanged(this.activeContent);
    },

    addSkipButton: function () {
        if (this.skipButton) {
            return;
        }
        const skipButton = this.skipButton = new cc.Sprite(bundles.dialogues.frames.skip_button_png);
        skipButton.setAlignment(cleverapps.styles.DialogueView.skipButton);
        this.addChild(skipButton, 2);

        cleverapps.UI.applyHover(skipButton);
        cleverapps.UI.onClick(skipButton, () => {
            this.dialogue.close();
        });
    },

    showUp: function (silent) {
        if (this.shown) {
            return;
        }
        this.shown = true;
        this.activeContent.showUp(silent);
    },

    close: function (silent) {
        const onClose = function () {
            this.dialogue.trigger("beforeClose");
            ComponentMap.get(this, WindowComponent).closeWindow();
            this.dialogue.finishClose();
        }.bind(this);

        if (!this.activeContent) {
            onClose();
            return;
        }

        this.activeContent.onClose(silent, onClose);
    },

    listBundles: function (dialogue) {
        return dialogue.bundlesToLoad.slice();
    }
});

DialogueView.getCtor = function () {
    if (["garden", "ladacha", "woodenmerge2"].includes(cleverapps.config.name)) {
        return [DialogueViewVertical, DialogueViewVertical, DialogueViewHorizontal][cleverapps.resolution.mode];
    }
    if (cleverapps.config.name === "mergecraft") {
        return [DialogueViewVertical, DialogueViewHorizontal, DialogueViewHorizontal][cleverapps.resolution.mode];
    }
    return DialogueViewHorizontal;
};

cleverapps.styles.DialogueView = {
    skipButton: {
        x: { align: "right", dx: 0 },
        y: { align: "top", dy: -50 }
    }
};